"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function ArrowLeft(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M8.39895924,0.398959236 L9.60104076,1.60104076 L4.20191847,6.99995924 L16,7 L16,9 L4.20191847,8.99995924 L9.60104076,14.3989592 L8.39895924,15.6010408 L0.797918472,8 L8.39895924,0.398959236 Z" })));
}
exports.default = ArrowLeft;
//# sourceMappingURL=ArrowBack.js.map